import { JSX } from "react";
import { HeadExtractoLoteria, INumeroExtracto } from "../interfaces/interfaces";
import GrillaNrosPorLoteria from "./grillaNrosPorLoteria";
import { v4 as uuid } from "uuid";

interface Iprops {
  numerosModalidad: INumeroExtracto[];
  loteriasHead: HeadExtractoLoteria[];
}

const ColumnExtracto = (props: Iprops) => {
  const { loteriasHead, numerosModalidad } = props;

  return <>{getContainerExtracto(loteriasHead)}</>;

  function getContainerExtracto(loteriasHead: HeadExtractoLoteria[]) {
    let itemsGral: JSX.Element[] = [];

    // Mapeo de IDs conocidos a nombres de extracto para CSS/estilos específicos
    const idToExtractMap: { [key: number]: string } = {
      1: "ExtractoER",
      2: "ExtractoCABA",
      3: "ExtractoBSAS",
      4: "ExtractoORO",
      5: "ExtractoSF",
      6: "ExtractoC",
    };

    for (const i of loteriasHead) {
      let keyC = `colkey${i.idModalidad}${uuid()}`;

      let numerosLoteria = numerosModalidad
        .filter((numero) => numero.NroLoteria === i.NroLoteria)
        .sort((a, b) => a.Ubicacion - b.Ubicacion);

      // Usar el ID del mapeo o generar uno dinámico para nuevas loterías
      const idExtractos = idToExtractMap[i.NroLoteria] || `Extracto${i.NroLoteria}`;

      itemsGral.push(
        <GrillaNrosPorLoteria
          key={keyC}
          idExtractos={idExtractos}
          loteria={i}
          numerosLoteria={numerosLoteria}
        />
      );
    }

    return (
      <>
        <div className="extractosGral">{itemsGral}</div>
      </>
    );
  }
};

export default ColumnExtracto;
